export class ACTToolbarService {
  private toolbars = [];
  constructor(private $mdComponentRegistry, private $q: ng.IQService) {
  }

  public getToolbar(name: string) {
    return {
      then: (callbackFn) => {
        let instance;
        let promise;

        instance = this.toolbars[name] ? this.toolbars[name] : this.$mdComponentRegistry.get(name);
        promise = instance ? this.$q.when(instance) : this.waitForInstance(name);
        return promise.then(callbackFn || angular.noop);
      }
    };
  }

  public register(newToolbar: any) {
    return this.toolbars[newToolbar.name] = newToolbar;
  }

  public unRegister(name: string) {
    delete this.toolbars[name];
  }
  /*
   * Deferred lookup of component instance using $component registry
   */
  public waitForInstance(name: string) {
    return this.$mdComponentRegistry
      .when(name)
      .then((it) => {
        return this.toolbars[it.$$mdHandle];
      });
  }
}